
(function (angular, app) {
    'use strict';

    function getFirstVisibleShortcutAnchor() {
        var bar = document.getElementById('menu-navigation-bar');
        if (!bar) {
            return null;
        }
        var links = bar.querySelectorAll('li.navigation-link a[href]');
        var i;
        var li;
        var a;
        for (i = 0; i < links.length; i++) {
            a = links[i];
            li = a.closest('li');
            if (!li) {
                continue;
            }
            if (li.classList.contains('menu-hidden')) {
                continue;
            }
            if (window.getComputedStyle(li).display === 'none') {
                continue;
            }
            return a;
        }
        return null;
    }

    app.directive('spFocusManagement', ['$timeout', '$compile', 'Util', function ($timeout, $compile, Util) {
        return {
            restrict: 'A',
            scope: {
                previousElementSelector: '@',
                nextElementSelector: '@'
            },
            link: function ($scope, $element) {
                var focusableElements,
                    previousElement = angular.element(document.querySelector($scope.previousElementSelector)),
                    nextElement = angular.element(
                        $scope.nextElementSelector ? document.querySelector($scope.nextElementSelector) : null
                    ),
                    firstFocusTrapElement,
                    lastFocusTrapElement,
                    menuNavigationBarElement;

                $timeout(function () {
                    focusableElements = $element[0].querySelectorAll('button, [ng-click], [href], input, select, textarea');

                    previousElement && previousElement.bind('keydown', _onPreviousElementKeyDown);

                    menuNavigationBarElement = document.getElementById('menu-navigation-bar');
                    if (menuNavigationBarElement) {
                        angular.element(menuNavigationBarElement).bind('keydown', _onMenuNavigationBarKeyDown);
                    } else if (nextElement && nextElement.length) {
                        nextElement.bind('keydown', _onNextElementKeyDown);
                    }

                    firstFocusTrapElement = angular.element('<div class="sp-focus-trap" tabindex="-1"></div>').bind('focus', _onFirstFocusTrapFocus);
                    lastFocusTrapElement = angular.element('<div class="sp-focus-trap" tabindex="-1"></div>').bind('focus', _onLastFocusTrapFocus);

                    $element.prepend($compile(firstFocusTrapElement)($scope)[0]);
                    $element.append($compile(lastFocusTrapElement)($scope)[0]);
                }, 100);

                function _onFirstFocusTrapFocus() {
                    previousElement[0].focus();
                }

                function _onLastFocusTrapFocus() {
                    var next = getFirstVisibleShortcutAnchor();
                    if (next) {
                        next.focus();
                    } else if (nextElement && nextElement.length) {
                        nextElement[0].focus();
                    }
                }

                function _onPreviousElementKeyDown(event) {
                    if (event.which === 9 && !event.shiftKey) {
                        event.preventDefault();
                        $timeout(function () {
                            focusableElements = $element[0].querySelectorAll('button, [ng-click], [href], input, select, textarea');
                            if (focusableElements && focusableElements.length) {
                                focusableElements[0].focus();
                            } else {
                                var next = getFirstVisibleShortcutAnchor();
                                if (next) {
                                    next.focus();
                                } else if (nextElement && nextElement.length) {
                                    nextElement[0].focus();
                                }
                            }
                        }, 0);
                    }
                }

                function _onNextElementKeyDown(event) {
                    if (event.which === 9 && event.shiftKey) {
                        event.preventDefault();
                        if (previousElement && previousElement.length) {
                            previousElement[0].focus();
                        } else if (focusableElements && focusableElements.length) {
                            focusableElements[focusableElements.length - 1].focus();
                        }
                    }
                }

                function _onMenuNavigationBarKeyDown(event) {
                    if (event.which !== 9 || !event.shiftKey) {
                        return;
                    }
                    var firstShortcut = getFirstVisibleShortcutAnchor();
                    if (!firstShortcut) {
                        return;
                    }
                    var target = event.target;
                    if (target !== firstShortcut && !firstShortcut.contains(target)) {
                        return;
                    }
                    event.preventDefault();
                    if (previousElement && previousElement.length) {
                        previousElement[0].focus();
                    } else if (focusableElements && focusableElements.length) {
                        focusableElements[focusableElements.length - 1].focus();
                    }
                }

                Util.currentScopeListener($scope, function () {
                    firstFocusTrapElement && firstFocusTrapElement.unbind('focus', _onFirstFocusTrapFocus);
                    lastFocusTrapElement && lastFocusTrapElement.unbind('focus', _onLastFocusTrapFocus);
                    previousElement && previousElement.unbind('keydown', _onPreviousElementKeyDown);
                    if (menuNavigationBarElement) {
                        angular.element(menuNavigationBarElement).unbind('keydown', _onMenuNavigationBarKeyDown);
                    } else if (nextElement && nextElement.length) {
                        nextElement.unbind('keydown', _onNextElementKeyDown);
                    }
                });
            }
        };
    }]);

})(angular, app);